import { Component, OnInit } from '@angular/core';
import { Adal5Service } from 'adal-angular5';
import { environment } from '../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Idle } from '@ng-idle/core';
import { Subscription } from 'rxjs/Subscription';
import { LocalCacheService } from './core/local-cache/local-cache.service';
import { SharedCallsService } from '../app/shared/services/shared-calls.service';
declare function userVoice(): any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'app';
  idleSubscription: Subscription;
  timeoutSubscription: Subscription;


  constructor(private adalSvc: Adal5Service,
    public idle: Idle,
    private translate: TranslateService,
    private storage: LocalCacheService,
    private sharedSerice: SharedCallsService) {
    this.adalSvc.init(environment.adalConfig);
    translate.addLangs(environment.supportedLanguages);
    translate.setDefaultLang(environment.defaultLanguage);
  }
  ngOnInit(): void {
    this.adalSvc.handleWindowCallback();
    this.getUserDetails();
    userVoice(); // userVoice.js call for widget
  }

  getUserDetails() {
    this.storage.storeData('loggedEmailId', this.adalSvc.userInfo.username);
    this.sharedSerice.getUserRole(this.adalSvc.userInfo.username + '/').subscribe(response => {
      if (response.status === 200) {
        this.storage.storeData('userId', response.result.userId, 'session');
        this.storage.storeData('userRole', response.result.roleName, 'session');
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/app.component.ts